import { IJsonScenario, ELocalStorageItems, Themes, Theme } from '@libs/types';
import { findTheme, resolveTheme, processThemeJson } from '@libs/network-utils';

export const resolveScenarioTheme = async (scenario: IJsonScenario): Promise<Theme | undefined> => {
    const page = scenario.pages?.[0];
    const configuration = page?.configuration ?? scenario.configuration ?? {};
    const themes = configuration.themes ?? ([] as Themes);
    const pageThemeName = page?.themeName;

    const themeEntry = findTheme(themes, pageThemeName);
    if (!themeEntry) return undefined;

    const themeHash = themeEntry.themeHash ?? '';

    const stored = localStorage?.getItem(ELocalStorageItems.THEME);
    const isValidStored = !!stored && !['undefined', 'null', '{}'].includes(stored);

    try {
        if (isValidStored) {
            const parsedStored = JSON.parse(stored);
            const storedHash = parsedStored?.themeHash ?? '';
            if (themeHash && storedHash && themeHash === storedHash) {
                return parsedStored.theme as Theme;
            }
        }
        const resolved = await resolveTheme(themeEntry);
        const parsed = processThemeJson(resolved);
        const resolvedHash = parsed.themeHash ?? themeHash;

        if (isValidStored) localStorage?.removeItem(ELocalStorageItems.THEME);
        if (resolvedHash) {
            localStorage?.setItem(ELocalStorageItems.THEME, JSON.stringify({ themeHash: resolvedHash, theme: parsed }));
        }
        return parsed;
    } catch (e) {
        console.error('resolveScenarioTheme:', e);
        return undefined;
    }
};
